<template>
  <div class="container px-0">
    <!--header-->
    <div class="row">
      <div class="col-12">
        <content-header
          :links="[
            {
              label: 'Questions',
              active: current_page === 'QUESTIONS',
              on_click: setCurrentPage,
              on_click_params: ['QUESTIONS'],
              hide: !canEditQuestions,
            },
            {
              label: 'Alerts',
              active: current_page === 'ALERTS',
              on_click: setCurrentPage,
              on_click_params: ['ALERTS'],
            },
            {
              label: 'NCR',
              active: current_page === 'NCR',
              on_click: setCurrentPage,
              on_click_params: ['NCR'],
              hide: !canViewNCR,
            },
          ]"
        />
      </div>
    </div>

    <modal ref="modal" title="Editing a Form">
      <div class="form-group row">
        <div class="col-12">
          <p>By changing the form questions, this form will no longer be associated with the form "<span class="font-weight-bold">{{ form?.form?.name }}</span>".</p>
          <p>Any changes to the form "<span class="font-weight-bold">{{ form?.form?.name }}</span>" will not be synced with this form.</p>
          <p>Do you want to continue?</p>
        </div>
      </div>
      <div class="form-group row">
        <div v-if="!saving" class="col-12 text-right">
          <button class="btn btn-secondary px-2" @click="closeModal">Cancel</button>
          <button class="btn btn-primary px-2 ml-2" @click="finalise">Save new form</button>
        </div>
        <loader v-else></loader>
      </div>
    </modal>

    <!--questions-->
    <div class="row mt-4" v-show="current_page === 'QUESTIONS'">
      <div class="col-12">
      <div v-if="canEditTitle" class="mb-3  col-12">
        <h5 class="text-secondary">Form title</h5>
        <div class="d-flex">
            <input
              type="text"
              class="form-control col-6 col-md-7 col-lg-8"
              placeholder="Form title"
              v-model="name"
            />
            <button v-if="!isCustom" @click="resetToDefault" class="ml-2 btn btn-primary">Reset to default</button>
        </div>
      </div>
      <div class="col-12">
        <form-custom-template
          v-model="build"
          :form="form"
          :its_form_instance="its_form_instance"
          :hide_options="!canEditForm"
        ></form-custom-template>
      </div>
    </div>
    </div>

    <div class="row mt-4" v-show="current_page === 'ALERTS'">
      <div v-if="isStaticForm" class="mb-3 col-12">
        <h5 class="text-secondary">Form title</h5>
        <div class="d-flex">
          <input
            type="text"
            class="form-control col-6 col-md-7 col-lg-8"
            placeholder="Form title"
            v-model="name"
          />
          <button v-if="!isCustom" @click="resetToDefault" class="ml-2 btn btn-primary">Reset to default</button>
        </div>
      </div>
      <div class="col-12">
        <form-alerts-component v-if="!canEditExpiry" v-model="build"/>
      </div>
    </div>
    <div class="row mt-4" v-show="current_page === 'NCR'">
      <div class="col-6">
        <label>NCR Policy</label>
        <textarea
          name=""
          class="form-control"
          style="resize: none"
          rows="20"
          v-model="ncr_policy_edit"
        ></textarea>
      </div>
      <div class="col-6">
        <label>Defect Policy</label>
        <textarea
          name=""
          class="form-control"
          style="resize: none"
          rows="20"
          v-model="defect_policy_edit"
        ></textarea>
      </div>
    </div>

    <form-preview-modal ref="form_preview_modal" :form="formWithBuild" :name="name"></form-preview-modal>
  </div>
</template>

<script>
import FormCustomTemplate from "../forms/FormCustomTemplate";
import FormAlertsComponent from "../forms/FormAlertsComponent";
import FormPreviewModal from "../forms/FormPreviewModal.vue";
import Modal from "../general_components/Modal"

export default {
  name: "FormCreateEditPage",

    components: {
        FormAlertsComponent,
        FormCustomTemplate,
        Modal,
        FormPreviewModal,
    },

  props: [
    "form_types",
    "form",
    "its_form_instance",
    "update",

    "store_url",
    "back_url",

    "ncr_policy",
    "defect_policy",
  ],

  data() {
    return {
      name: "",
      build: {},

      _form: null,
      saving: false,
      alerts_page: false,
      current_page: "QUESTIONS",

      ncr_policy_edit: "",
      defect_policy_edit: "",
      reset_title: false,
      errors: [],
    };
  },

  beforeMount() {
    window.addEventListener("LAYOUT:primary_button", this.save);
    window.addEventListener("LAYOUT:cancel_button", this.cancel);
    window.addEventListener("LAYOUT:secondary_button", this.preview);

    this.ncr_policy_edit = this.ncr_policy;
    this.defect_policy_edit = this.defect_policy;

    if (this.its_form_instance) {
      this.name = this.form.form.name;
      this._form = this.form.form;
      this.build = this.form.settings;
    } else if (this.form) {
      this._form = this.form;
      this.name = this.form.name;
      this.build = this.form.settings;
    }

    if (!this.canEditForm && !this.canEditQuestions) {
      this.current_page = "ALERTS";
    }
  },

  methods: {
    closeModal(){
      this.$refs.modal.closeModal(null, true)
    },

    save(){
      if(this.hasChanged){
        return this.$refs.modal.openModal()
      }

      this.finalise()
    },

    finalise() {
      this.errors = [];

      let _this = this;

      if (_this.saving) return;

      if (this.update) {
        axios
          .patch(_this.store_url, {
            name: this.name,
            build: this.build,
            ncr_policy: _this.ncr_policy_edit,
            defect_policy: _this.defect_policy_edit,
            reset_title: _this.reset_title
          })
          .then(function (response) {
            _this.saving = false;
            if(_this.reset_title == true) {
              window.location.reload();
            } else {
              if (_this.back_url) window.location.href = _this.back_url;
            }
          })
          .catch(function (error) {
            _this.saving = false;

            if (error.response.data.errors !== undefined) {
              Object.values(error.response.data.errors).forEach((err, i) => {
                _this.errors.push(`<li>${err[0]}</li>`);
              });
            }

            if (_this.errors.length >= 2) {
              Vue.$toast.open({
                message: `There were ${
                  _this.errors.length
                } errors: ${_this.errors.join("")}`,
                type: "error",
              });
            } else if (_this.errors.length === 1) {
              Vue.$toast.open({
                message: `There was an error: ${_this.errors.join("")}`,
                type: "error",
              });
            }
          });
      } else {
        axios
          .post(_this.store_url, {
            name: this.name,
            build: this.build,
          })
          .then(function (response) {
            _this.saving = false;
            if (_this.back_url) window.location.href = _this.back_url;
          })
          .catch(function (error) {
            _this.saving = false;

            if (error.response.data.errors !== undefined) {
              Object.values(error.response.data.errors).forEach((err, i) => {
                _this.errors.push(`<li>${err[0]}</li>`);
              });
            }

            if (_this.errors.length >= 2) {
              Vue.$toast.open({
                message: `There were ${
                  _this.errors.length
                } errors: ${_this.errors.join("")}`,
                type: "error",
              });
            } else if (_this.errors.length === 1) {
              Vue.$toast.open({
                message: `There was an error: ${_this.errors.join("")}`,
                type: "error",
              });
            }
          });
      }
    },
    cancel() {
      window.location.href = this.back_url;
    },

    preview() {
        this.$refs.form_preview_modal.open();
    },

    resetToDefault(){
      this.reset_title = true;
      this.save();
    },

    setCurrentPage(page) {
      this.current_page = page;

      if (page === "QUESTIONS" && this.canEditQuestions)
        this.current_page = page;
    },
  },
  computed: {

    standardForm() {
      if (this.form === undefined) return false;

      if (this.form && this.form.type) return this.form.type !== "custom";
      else return this.form.form.type !== "custom";
    },

    canEditForm() {
      if (this.form === undefined) return true;

      if (this.form && this.form.type) return this.form.type === "custom";
      else return this.form.form.type === "custom";
    },

    isCustom(){
      if (this.form === undefined) return true;

      if (this.form && this.form.type) return this.form.type === "custom";
      else return this.form.form.type === "custom";
    },

    canEditTitle() {
      if (this.form === undefined && this.its_form_instance === undefined) return true;

      return this.form === undefined
        || this.its_form_instance
          ? this.form.form.type === 'custom'
          : this.form.type === 'custom'
    },

    isStaticForm() {
        return this.form !== undefined && this.form.type !== 'custom';
    },

    canEditQuestions() {
      if (this.form === undefined) return true;

      if (
        (this.form && this.form.type === "custom") ||
        (this.form.form && this.form.form.type === "custom")
      )
        return true;

      //This only allows the Library level face_fit_test to be edited
      if (this.form && this.form.type === "face_fit_test") return true;

      return false;
    },

    canViewNCR() {
      return this.form !== undefined && this.form.type === "ncr_defect_notice";
    },

    canEditExpiry() {
      const expiryHiddenFromList = [
        'face_fit_test',
        'havs',
        'initial_briefing',
        'ncr_defect_notice',
        'ppe_register',
        'site_operative_register',
        'site_survey_inspection_report',
        'snag_list',
        'training_certificates',
      ];

      return this.form !== undefined && expiryHiddenFromList.includes(this.form.type);
    },

    hasChanged(){
      if(!this.its_form_instance){ //anywhere this is used not on form instances should not track this
        return false
      }

      if(this.form.form.is_company_library != 1){  //If this form is not from the company library we won't be cloning
        return false
      }

      if(this.form.form.cloned_from_id !== null){ //We've already duplicated it at this point
        return false
      }

      if(this.canEditTitle && this.name !== this.form.form.name){
        return true
      }

      const currentQuestions = (this.build.questions ?? []).reduce((keyedQuestions, question) => ({
        ...keyedQuestions,
        [question.id]: question
      }), {})

      if(this.form.form.questions.length !== Object.keys(currentQuestions).length){ //If the number of questions is different we've modified the form
        return true;
      }

      return this.form.form.questions.some((question) => {
        const currentQuestion = currentQuestions[question.id] ?? null

        if(currentQuestion === null){ //If the question doesn't exist it has been deleted
          return true
        }

        if(['question', 'type', 'order'].some((field) => currentQuestion[field] !== question[field])){ //If the core question fields are different
          return true
        }

        if(['provide_image', 'providing_image_optional', 'provide_comment', 'providing_comment_optional', 'checkbox_other', 'required'].some((field) => currentQuestion?.settings?.[field] !== question?.settings?.[field])){ //If the settings are different
          return true;
        }

        if(question.has_options){
          const currentOptions = (currentQuestion?.options ?? []).reduce((keyedOptions, option) => ({
            ...keyedOptions,
            [option.id]: option
          }), {})

          return question.options.some(
            (option) => ['label', 'effect', 'is_free_text'].some((field) => option[field] !== currentOptions[option.id]?.[field])
          )
        }

        return false
      })
    },

    formWithBuild() {
        return {
          ...this._form,
          ...this.build,
        };
    }
  },
};
</script>
